import { Shield } from "lucide-react";
import { NAV, type NavItem } from "@/lib/nav";
import { useMe } from "./useMe";
import { t } from "@shared/i18n";

const ADMIN: NavItem = { id: "admin", label: t("Administration"), to: "/app/admin", icon: Shield, phase: null, description: t("Statistiques, formules et modules de la plateforme.") };

/** Navigation visible : modules actifs (interrupteurs d'administration) + administration si autorisée. */
export function useNav() {
  const { data: me } = useMe();
  const items = NAV.filter((n) => !n.flag || me?.flags?.[n.flag] !== false);
  return me?.isAdmin ? [...items, ADMIN] : items;
}
